const TOKEN_KEY = "lowi_auth_token";
const EXPIRY_KEY = "lowi_auth_expiry";
const USER_KEY = "lowi_auth_user";

export interface StoredAuth {
  accessToken: string;
  idToken?: string;
  expiresAt: number;
  user: {
    sub: string;
    email?: string;
    name?: string;
    picture?: string;
  };
}

export function storeAuth(auth: StoredAuth): void {
  localStorage.setItem(TOKEN_KEY, auth.accessToken);
  localStorage.setItem(EXPIRY_KEY, String(auth.expiresAt));
  localStorage.setItem(USER_KEY, JSON.stringify(auth.user));
}

export function getStoredToken(): string | null {
  const token = localStorage.getItem(TOKEN_KEY);
  const expiry = localStorage.getItem(EXPIRY_KEY);

  if (!token || !expiry) return null;

  if (Date.now() >= Number(expiry)) {
    clearStoredAuth();
    return null;
  }

  return token;
}

export function getStoredUser(): StoredAuth["user"] | null {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearStoredAuth(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EXPIRY_KEY);
  localStorage.removeItem(USER_KEY);
}
